const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const STORAGE_KEY = 'utm_params';

export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const utms = {};
  UTM_KEYS.forEach(key => {
    const value = params.get(key);
    if (value) utms[key] = value;
  });
  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
  }
}

export function getUtmParams() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}
